import React, { useState, useEffect, useRef } from "react";
import Translator, { __ } from "services/Translator";
import { Collapse, Dropdown } from "react-bootstrap";
import api from "services/api";
import { Link, useParams, useHistory, useLocation } from "react-router-dom";
import GamesFilter from "./GamesFilter";
import GameCategoryDropdown from "elements/GameElements/GameCategoryDropdown";
import StakeGameMenu from "elements/GameElements/StakeGameMenu";

export default function GamesMenu(props) {
  const history = useHistory();
  const location = useLocation();
  const params = useParams();
  const gamesCategory = params.category;
  return (
    <>
      <div className="favorite-game-menus">
        <br />
        <div className="common-heading">
          <div className="heading">Select your Favorite Category</div>
          <div className="sub-heading">
            Simple pricing with no hidden fees. It's free to start - no trial,
            no contract, no risk.
          </div>
        </div>
        <ul className="game-categories">
          <li
            className={
              location.pathname == "/games/table-games" ? "active" : ""
            }
          >
            <div className="category-icon">
              <img
                alt=""
                src={require("assets/winnabull/images/games/table-game-icon.png")}
              />
            </div>

            <label>Table Games</label>
            <Link
              className={
                "commonBtn secondaryBtn " +
                (location.pathname == "/games/table-games"
                  ? "primaryBtn"
                  : "secondaryBtn")
              }
              to="/games/table-games"
            >
              <span className="front">
                {location.pathname == "/games/table-games"
                  ? "Selected"
                  : "Select"}{" "}
                <svg
                  width="8"
                  height="13"
                  viewBox="0 0 8 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.5 1.35742L6.5 6.35742L1.5 11.3574"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </Link>
          </li>
          <li className={location.pathname == "/games/slots" ? "active" : ""}>
            <div className="category-icon">
              <img
                alt=""
                src={require("assets/winnabull/images/games/live-casino-icon.png")}
              />
            </div>

            <label>Slots Games</label>
            <Link
              className={
                "commonBtn  " +
                (location.pathname == "/games/slots"
                  ? "primaryBtn"
                  : "secondaryBtn")
              }
              to="/games/slots"
            >
              <span className="front">
                {location.pathname == "/games/slots" ? "Selected" : "Select"}{" "}
                <svg
                  width="8"
                  height="13"
                  viewBox="0 0 8 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.5 1.35742L6.5 6.35742L1.5 11.3574"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </Link>
          </li>
          <li
            className={
              location.pathname == "/games/live-casino" ? "active" : ""
            }
          >
            <div className="category-icon">
              <img
                alt=""
                src={require("assets/winnabull/images/games/slot-game-icon.png")}
              />
            </div>

            <label>Live Casino</label>
            <Link
              className={
                "commonBtn secondaryBtn " +
                (location.pathname == "/games/live-casino"
                  ? "primaryBtn"
                  : "secondaryBtn")
              }
              to="/games/live-casino"
            >
              <span className="front">
                {location.pathname == "/games/live-casino"
                  ? "Selected"
                  : "Select"}{" "}
                <svg
                  width="8"
                  height="13"
                  viewBox="0 0 8 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.5 1.35742L6.5 6.35742L1.5 11.3574"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </Link>
          </li>
        </ul>

        {/* <ul className="game-sub-categories">
          <li>
            <Link>
              <img
                alt=""
                src={require("assets/winnabull/images/games/icon-container.png")}
              />
              <label>Sub categories</label>
            </Link>
          </li>
          <li>
            <Link>
              <img
                alt=""
                src={require("assets/winnabull/images/games/icon-container.png")}
              />
              <label>Sub categories</label>
            </Link>
          </li>
          <li>
            <Link>
              <img
                alt=""
                src={require("assets/winnabull/images/games/icon-container.png")}
              />
              <label>Sub categories</label>
            </Link>
          </li>
          <li>
            <Link>
              <img
                alt=""
                src={require("assets/winnabull/images/games/icon-container.png")}
              />
              <label>Sub categories</label>
            </Link>
          </li>
        </ul> */}
        <StakeGameMenu {...props} />
      </div>
    </>
  );
}
